// extracted by mini-css-extract-plugin
export default {"advertisement":"advertisement_advertisement__FcBnK","advertisement_heading":"advertisement_advertisement_heading__qSS99"};